<template>
  <div v-wechat-title="title">
    <router-view></router-view>
    <Popup></Popup>
    <Question></Question>
    <UserName></UserName>
    <Vote></Vote>
  </div>
</template>

<script>
//import Vue from "vue";
import Popup from "../components/wap/Popup";
import $ from "jquery";
import Vote from "../components/pc/Vote";
import Question from "../components/pc/Question";
import UserName from "../components/pc/UserName";
import { $subscriber } from "fire-wind-water";
export default {
  name: "Pc",
  data() {
    return {
      title: "",
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i),
      scrollbar: null,
      webinarInfo: {}
    };
  },
  components: {
    Popup,
    Question,
    UserName,
    Vote
  },
  created() {
    //当前环境是 手机
    if (this.isMobile) {
      //不是本地
      if (window.location.href.indexOf("local") < 0) {
        if (window.location.href.indexOf("/pc/") > -1) {
          window.$sk.goto(
            window.location.href
              .replace(
                "74033b16de0316e83957a3fc2a529e26",
                "29ca13a4a29e0db78321cc6fe87b5ec1"
              )
              .replace("/pc/", "/wap/")
          );
        }
      } else {
        //本地调试
        if (window.location.href.indexOf("/pc/") > -1) {
          window.location.replace(
            window.location.href.replace("/pc/", "/wap/")
          );
        }
      }
    }
    this.init();
  },
  mounted() {
    $;
    //    $("body").css("overflow", "hidden");//滚动条兼容问题
    setTimeout(() => {
      //      this.scrollbar = new Vue.$geminiScrollbar({//滚动条兼容问题
      //        element: $('body')[0],
      //        autoshow: true
      //      }).create();
      $subscriber.emit("SetScrollDone");
    }, 1000);
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
        this.title = data.title;
        if (window.location.href.indexOf("meetingInfo") == -1) {
          $subscriber.emit("webinarInfo.meeting", data);
        }
      });
    }
  },
  watch: {
    ///监听路由变化更新滚动条//滚动条兼容问题
    //    $route() {
    //      let self = this;
    //      console.log('mac滚动条测试----进入$routeWatch');
    //      setTimeout(() => {
    //        console.log('mac滚动条测试----进入$routeWatch,SetTimeout');
    //        self.scrollbar.update();
    //      }, 1000);
    //    }
  }
};
</script>

<style scoped></style>
